import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Sync} from '@client/sync'
import {Link} from '@components/common/base/buttons'
import {trackDownload} from '../api/track-download'
import {useBoardAppearanceStore} from '../board-appearance-store'
import {TwListItemImg, TwSelected} from '../containers'
import {downloadImageByUrl} from './download-image-by-url'
import {UnsplashBasic} from './types'
import {wrapUrlUtm} from './wrap-url-utm'

export const TwAuthor = tw.div`
  absolute
  bottom-0
  left-0
  flex
  items-start
  px-4
  py-2
  z-10

  w-full
  invisible
  group-hover:visible
  truncate
  bg-[rgba(0,0,0,0.5)]
  hover:bg-[rgba(0,0,0,0.3)]
`
let prevSkin: string

export const UnsplashSkinItem = observer(({item}: {item: UnsplashBasic}) => {
  const [state, store] = useBoardAppearanceStore()

  const regularSkin = getUnsplashImageUrl(item)

  const onClick = async () => {
    if (prevSkin === regularSkin) {
      return
    }
    prevSkin = regularSkin

    void trackDownload(item.links.download_location)

    const skin = await downloadImageByUrl(regularSkin, item.id)
    if (skin) {
      const user = Sync.getCurrentUser()
      user.customSkins.push(skin)
      user.commit()

      store.calculateCustomSkins()
      await store.setTabBgSkin(skin)
      store.setUnsplashBgSkinRegular(regularSkin)
    }
  }

  const selected = regularSkin === state.unsplashBgSkinRegular
  const thumb = item.urls.thumb

  const userLink = wrapUrlUtm(item?.user?.links?.html)
  const userName = item?.user?.name

  return (
    <div className="relative group">
      <TwListItemImg $selected={selected} src={thumb} onClick={onClick} />

      {userLink && userName && (
        <TwAuthor>
          <Link
            color="secondary"
            style={{display: 'block', color: 'white'}}
            href={userLink}
            className="truncate"
          >
            {userName}
          </Link>
        </TwAuthor>
      )}
      {selected && <TwSelected />}
    </div>
  )
})

export const getUnsplashImageUrl = (item: UnsplashBasic) => {
  return item.urls.regular
}
